import gql from "graphql-tag";

export default gql`
  mutation ChangeAccountPermission($input: AccountPermissionChangeInput!) {
    changeAccountPermission(input: $input) {
      operationId
      revision
    }
  }
`;
